import { warn } from '@execonline-inc/logging';
import { InvalidUrlError, toUrlT } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import InvitationsOptionsStore from '.';
import { AppyError, callApi } from '../../../../../../Appy';
import ErrorActionableReaction, {
  EAProps,
  handleError,
} from '../../../../../../ErrorActionableReaction';
import { Error } from '../../../../../../ErrorHandling';
import { MissingLinkError, findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import { invitationsOptionsResourceDecoder } from './Decoders';
import { State } from './Types';

interface Props extends EAProps<InvitationsOptionsStore> {}

type OptionsError = AppyError | MissingLinkError | InvalidUrlError | Error;

const handleOptionsError = (store: InvitationsOptionsStore) => (error: OptionsError) => {
  switch (error.kind) {
    case 'missing-link-error':
    case 'invalid-url-error':
    case 'error':
      store.error('We are unable to process your request at this time');
      warn('InvitationsOptionsReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};

const buildUrl = (link: Link): Task<OptionsError, Link> =>
  toUrlT(link.href).map((url): Link => ({ ...link, href: url.href }));

const sendRequest = callApi(invitationsOptionsResourceDecoder, {});

class InvitationsOptionsReactions extends ErrorActionableReaction<
  InvitationsOptionsStore,
  State,
  Props
> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<OptionsError, ReadonlyArray<Link>>(store.invitationsStore.links)
          .andThen(findLinkT('options'))
          .andThen(buildUrl)
          .andThen(sendRequest)
          .fork(handleOptionsError(store), store.ready);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default InvitationsOptionsReactions;
